<template>
  <Layout title="Settings" description="Manage your workspace preferences">
  <div>
    <div class="d-flex gap-2 mb-2">
      <button
        class="btn  px-3 py-1  rounded-pill fw-semibold"
        :class="tab === 'profile' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
        @click="tab = 'profile'"
      >
        Profile
      </button>
      <button
        class="btn  px-3 py-1  rounded-pill fw-semibold"
        :class="tab === 'company' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
        @click="tab = 'company'"
      >
        Company
      </button>
      <!-- <button
        class="btn  px-3 py-1  rounded-pill fw-semibold"
        :class="tab === 'plans' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
        @click="tab = 'plans'"
      >
        Plans
      </button>
      <button
        class="btn  px-3 py-1  rounded-pill fw-semibold"
        :class="tab === 'topup' ? 'bg-white shadow-sm border' : 'bg-light text-muted border-0'"
        @click="tab = 'topup'"
        v-if="currentPlanDict && currentPlanDict.name && currentPlanDict.name.toLowerCase() !== 'enterprise'"
      >
        Top Up
      </button> -->
    </div>
  </div>
  
  <div class="card p-4 shadow-sm" v-if="tab === 'profile'">
    <h3 class="fw-bold">Profile Information</h3>
    <div class="card border-0 rounded-4 mt-3">
      <div class="card-body" style="padding: 0px !important">
        <!-- Tabs -->
        <ul class="nav mb-4 p-2 rounded-3 d-flex w-100" style="background-color:#f3f4f6;">
          <li 
            v-for="tab in detailTabs" 
            :key="tab" 
            class="nav-item flex-fill text-center"
          >
            <button
              class="nav-link w-100 px-4 py-2 fw-semibold"
              :class="activeTab === tab ? 'active-tab' : 'inactive-tab'"
              @click="activeTab = tab"
            >
              {{ tab }}
            </button>
          </li>
        </ul>
      </div>
    </div>
    <form @submit.prevent="saveProfile">
      <!-- Identity Section -->
      <div v-if="activeTab === 'Identity'" class="row g-3">
        <!-- Legal Name -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Legal Name *</label>
          <input
            v-model.trim="form.legalName"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter legal name"
          />
        </div>

        <!-- Preferred Name -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Preferred Name</label>
          <input
            v-model.trim="form.name"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter preferred name"
          />
        </div>

        <!-- NRIC / Passport -->
        <!-- <div class="col-md-6">
          <label class="form-label fw-semibold">NRIC / Passport *</label>
          <input
            v-model.trim="form.nricPassport"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter NRIC / Passport"
          />
        </div> -->

        <!-- Date of Birth -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Date of Birth *</label>
          <input
            v-model="form.dob"
            type="date"
            class="form-control rounded-3"
          />
        </div>

        <!-- Nationality -->
        <!-- <div class="col-md-6">
          <label class="form-label fw-semibold">Nationality *</label>
          <select
            v-model="form.nationality"
            class="form-select rounded-3"
          >
            <option disabled value="">Select nationality</option>
            <option>Singaporean</option>
            <option>Malaysian</option>
            <option>Other</option>
          </select>
        </div> -->

        <!-- Employee Status -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Employee Status *</label>
          <select
            v-model="form.employeeStatus"
            class="form-select rounded-3"
            disabled=true
          >
            <option disabled value="">Select status</option>
            <option>Active</option>
            <option>Pending</option>
            <option>Probation</option>
            <option>Resigned</option>
            <option>Terminated</option>
          </select>
        </div>
      </div>

      <!-- Contact Section -->
      <div v-if="activeTab === 'Contact'" class="row g-3">
        <!-- Personal Email -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Personal Email *</label>
          <input
            v-model.trim="form.personalEmail"
            type="email"
            class="form-control rounded-3"
            placeholder="Enter personal email"
          />
        </div>

        <!-- Work Email -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Work Email *</label>
          <input
            v-model.trim="form.email"
            type="email"
            class="form-control rounded-3"
            placeholder="Enter work email"
          />
        </div>

        <!-- Mobile Number -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Mobile Number *</label>
          <input
            v-model.trim="form.mobileNumber"
            type="text"
            class="form-control rounded-3"
            placeholder="+65 9123 4567"
          />
        </div>

        <!-- Photo Upload -->
        <!-- <div class="col-md-6">
          <label class="form-label fw-semibold">Photo</label>
          <div class="d-flex align-items-center gap-2">
            <input
              type="file"
              class="form-control"
              @change="onPhotoUpload"
              accept="image/png, image/jpeg"
            />
            <div v-if="form.photoUrl" class="mt-2">
              <img
                :src="form.photoUrl"
                alt="Employee Photo"
                class="img-thumbnail"
                style="max-height: 80px;"
              />
            </div>
          </div>
        </div> -->

        <!-- Home Address -->
        <div class="col-12">
          <label class="form-label fw-semibold">Home Address *</label>
          <textarea
            v-model.trim="form.homeAddress"
            class="form-control rounded-3"
            rows="2"
            placeholder="Enter home address"
          ></textarea>
        </div>

        <!-- Emergency Contacts -->
        <!-- <div class="col-12">
          <hr style="margin-top:10px; margin-bottom:20px;" />
          <h6 class="fw-bold">Emergency Contacts (At least one required)</h6>
        </div>

        <div
          class="col-md-4"
          v-for="(contact, index) in form.emergencyContacts"
          :key="index"
        >
          <label class="form-label fw-semibold">Contact Name *</label>
          <input
            v-model.trim="contact.name"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter contact name"
          />
        </div>

        <div
          class="col-md-4"
          v-for="(contact, index) in form.emergencyContacts"
          :key="'rel-' + index"
        >
          <label class="form-label fw-semibold">Relationship *</label>
          <select
            v-model="contact.relationship"
            class="form-select rounded-3"
          >
            <option disabled value="">Select relationship</option>
            <option>Spouse</option>
            <option>Parent</option>
            <option>Sibling</option>
            <option>Friend</option>
            <option>Other</option>
          </select>
        </div>

        <div
          class="col-md-4"
          v-for="(contact, index) in form.emergencyContacts"
          :key="'phone-' + index"
        >
          <label class="form-label fw-semibold">Phone Number *</label>
          <input
            v-model.trim="contact.phone"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter phone number"
          />
        </div> -->

        <!-- Add Contact Button -->
        <!-- <div class="col-12">
          <button
            class="btn btn-outline-secondary btn-sm rounded-pill mt-2"
            @click.prevent="form.emergencyContacts.push({ name: '', relationship: '', phone: '' })"
          >
            Add Emergency Contact
          </button>
        </div> -->
      </div>
      <!-- Job Info Section -->
      <div v-if="activeTab === 'Job Info'" class="row g-3">
        <!-- Position / Job Title -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Job Title / Position *</label>
          <input
            v-model.trim="form.position"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter job title"
            disabled=true
          />
        </div>

        <!-- Grade / Level -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Grade / Level</label>
          <input
            v-model.trim="form.gradeLevel"
            type="text"
            class="form-control rounded-3"
            placeholder="e.g. Junior, Senior"
            disabled=true
          />
        </div>

        <!-- Department -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Department *</label>
          <input
            v-model.trim="form.department"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter department"
            disabled=true
          />
        </div>

        <!-- Cost Centre -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Cost Centre</label>
          <input
            v-model.trim="form.costCentre"
            type="text"
            class="form-control rounded-3"
            placeholder="e.g. CC-ENG-001"
            disabled=true
          />
        </div>

        <!-- Manager -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Manager (Employee ID)</label>
          <input
            v-model.trim="form.managerId"
            type="text"
            class="form-control rounded-3"
            placeholder="Enter manager ID"
            disabled=true
          />
        </div>

        <!-- Employment Type -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Employment Type *</label>
          <select 
            disabled=true
            v-model="form.employmentType"
            class="form-select rounded-3"
          >
            <option disabled value="">Select type</option>
            <option>Permanent</option>
            <option>Contract</option>
            <option>Intern</option>
            <option>Part-time</option>
          </select>
        </div>

        <!-- Work Arrangement -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Work Arrangement *</label>
          <select
            v-model="form.workArrangement"
            class="form-select rounded-3"
            disabled=true

          >
            <option disabled value="" >Select arrangement</option>
            <option>Onsite</option>
            <option>Remote</option>
            <option>Hybrid</option>
          </select>
        </div>

        <!-- Work Location -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Work Location / Site</label>
          <input
            disabled=true
            v-model.trim="form.workLocation"
            type="text"
            class="form-control rounded-3"
            placeholder="e.g. Singapore HQ"
          />
        </div>

        <!-- Join Date -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Join Date *</label>
          <input
            disabled=true
            v-model="form.joinDate"
            type="date"
            class="form-control rounded-3"
          />
        </div>

        <!-- Probation End Date -->
        <div class="col-md-6">
          <label class="form-label fw-semibold">Probation End Date</label>
          <input
            disabled=true
            v-model="form.probationEndDate"
            type="date"
            class="form-control rounded-3"
          />
        </div>

        <!-- Notice Period -->
        <!-- <div class="col-md-6">
          <label class="form-label fw-semibold">Notice Period (months)</label>
          <input
            disabled=true
            v-model.number="form.noticePeriod"
            type="number"
            min="0"
            class="form-control rounded-3"
            placeholder="e.g. 2"
          />
        </div> -->
      </div>

      <!-- Payroll Section -->
      <div v-if="activeTab === 'Payroll'" class="row g-3">
        <!-- Employment Basis -->
        <div class="col-md-12">
          <label class="form-label fw-semibold">Employment Basis *</label>
          <select v-model="form.employmentBasis" class="form-select rounded-3" disabled=true>
            <option value="fulltime">Full-time</option>
            <option value="parttime">Part-time</option>
          </select>
        </div>

        <!-- Full-time Fields -->
        <template v-if="form.employmentBasis === 'fulltime'">
          <div class="col-md-6">
            <label class="form-label fw-semibold">Base Salary Amount *</label>
            <input
              v-model.number="form.baseSalary"
              type="number"
              class="form-control rounded-3"
              placeholder="e.g. 8000"
              disabled=true
            />
          </div>

          <div class="col-md-6">
            <label class="form-label fw-semibold">Pay Schedule *</label>
            <select v-model="form.paySchedule" disabled=true class="form-select rounded-3">
              <option value="Monthly">Monthly</option>
            </select>
          </div>

          <!-- <div class="col-md-6">
            <label class="form-label fw-semibold">CPF Status *</label>
            <select v-model="form.cpfStatus" disabled=true class="form-select rounded-3">
              <option>Citizen</option>
              <option>PR Year 1</option>
              <option>PR Year 2+</option>
              <option>No CPF</option>
            </select> 
          </div>-->

          <!-- <div class="col-md-6">
            <label class="form-label fw-semibold">Tax Residency *</label>
            <select v-model="form.taxResidency" disabled=true class="form-select rounded-3">
              <option>Resident</option>
              <option>Non-resident</option>
            </select>
          </div> -->

          <!-- <div class="col-md-6">
            <label class="form-label fw-semibold">IRAS Auto-Inclusion *</label>
            <select v-model="form.irasAutoInclusion" disabled=true class="form-select rounded-3">
              <option>Yes</option>
              <option>No</option>
            </select>
          </div> -->
        </template>

        <!-- Part-time Fields -->
        <template v-else>
          <div class="col-md-6">
            <label class="form-label fw-semibold">Hourly Rate *</label>
            <input
              disabled=true
              v-model.number="form.hourlyRate"
              type="number"
              class="form-control rounded-3"
              placeholder="e.g. 15.00"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-semibold" >Hours Worked (per month)</label>
            <input
              disabled=true
              v-model.number="form.hoursWorked"
              type="number"
              class="form-control rounded-3"
              placeholder="e.g. 120"
            />
          </div>
        </template>

        <!-- Bank Details -->
        <hr /><br />
        <div class="col-12 mt-3">
          <h6 class="fw-bold">Bank Details</h6>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label fw-semibold">Account Name *</label>
              <input
                v-model.trim="form.bankDetails.accountName"
                type="text"
                class="form-control rounded-3"
                placeholder="Enter account name"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Bank Name *</label>
              <input
                v-model.trim="form.bankDetails.bankName"
                type="text"
                class="form-control rounded-3"
                placeholder="Enter bank name"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Branch Code</label>
              <input
                v-model.trim="form.bankDetails.branchCode"
                type="text"
                class="form-control rounded-3"
                placeholder="Enter branch code"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label fw-semibold">Account Number *</label>
              <input
                v-model.trim="form.bankDetails.accountNumber"
                type="text"
                class="form-control rounded-3"
                placeholder="Enter account number"
              />
            </div>
          </div>
        </div>

        <!-- Allowances & Deductions -->
        <div class="col-12 mt-3" v-if="form.allowances.length">
          <h6 class="fw-bold">Allowances & Deductions</h6>
          <div
            class="p-2 border rounded-3 mb-2"
            v-for="(item, index) in form.allowances"
            :key="'allow-' + index"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="fw-semibold">{{ item.name }}</div>
                <div
                  :class="item.amount > 0 ? 'text-success fw-semibold' : 'text-danger fw-semibold'"
                >
                  {{ item.amount > 0 ? '+ $' + item.amount : '- $' + Math.abs(item.amount) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 mt-3" v-if="form.payrollHistory.length">
          <h6 class="fw-bold">Monthly Payroll History</h6>
          <table class="table table-bordered text-sm">
            <thead class="table-light">
              <tr>
                <th>Month</th>
                <th>Base</th>
                <th>Net</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in form.payrollHistory" :key="index">
                <td>{{ item.month }}</td>
                <td>${{ item.base }}</td>
                <td>${{ item.net }}</td>
                <td>{{ item.status }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Download Button -->
          <div class="d-flex justify-content-end mt-2">
            <button 
              class="btn btn-outline-secondary rounded-pill btn-sm"
              @click="downloadPayroll"
            >
              Download Records
            </button>
          </div>
        </div>
      </div> 

      <!-- Compliance Section -->
      <div v-if="activeTab === 'Compliance'" class="row g-3">
        <!-- Contract & Compliance -->
        <div class="col-12" v-if="form.contractSigned">
          <h6 class="fw-bold mb-3">Contract & Compliance</h6>
            <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label fw-semibold">Contract Signed</label>
                  <input
                    v-model="form.contractSigned"
                    type="datetime-local"
                    class="form-control rounded-3"
                  />
                </div>
            </div>
        </div>

        <!-- Leave Entitlements -->
        <div class="col-12" v-if="form.leaveEntitlements.length">
          <h6 class="fw-bold mb-3">Leave Entitlements</h6>
          <div class="row g-3">
            <div class="col-md-6" v-for="(leave, index) in form.leaveEntitlements" :key="index">
              <div class="p-3 border rounded-3 bg-light">
                <div class="fw-semibold mb-2">
                  <input
                    class="form-control form-control-sm rounded-3 fw-semibold"
                    v-model="leave.type"
                    placeholder="Leave Type (e.g. Annual Leave)"
                    disabled=true
                  />
                </div>
                <div class="mb-2">
                  <label class="form-label small">Entitlement (days)</label>
                  <input
                    v-model.number="leave.entitlement"
                    type="number"
                    class="form-control form-control-sm rounded-3"
                    disabled=true
                  />
                </div>
                <div>
                  <label class="form-label small">Balance (days)</label>
                  <input
                    v-model.number="leave.balance"
                    type="number"
                    class="form-control form-control-sm rounded-3"
                    disabled=true
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <button
            class="btn btn-outline-secondary btn-sm rounded-pill mt-3"
            @click.prevent="form.leaveEntitlements.push({ type: '', entitlement: 0, balance: 0 })"
          >
            Add Leave Type
          </button> -->
        </div>
      </div>

      <!-- Additional Section -->
      <div v-if="activeTab === 'Additional'" class="additional-section">
        <!-- Training & Licenses -->
        <div class="section-block mb-4">
          <h6 class="fw-bold mb-3">Training & Licenses</h6>

          <!-- Existing Trainings -->
          <div 
            v-for="(training, index) in form.trainings" 
            :key="index" 
            class="p-3 border rounded-3 mb-2 d-flex justify-content-between align-items-center"
          >
            <div>
              <div class="fw-semibold">{{ training.name }}</div>
              <div class="text-muted small">{{ training.details }}</div>
            </div>
            <span 
              class="badge"
              :class="training.status === 'Completed' ? 'bg-primary' : 'bg-secondary'"
            >
              {{ training.status }}
            </span>
          </div>

          <!-- Add Button -->
          <button 
            class="btn btn-outline-secondary btn-sm rounded-pill mt-2"
            data-bs-toggle="modal"
            data-bs-target="#addTrainingModal"
          >
            Add Training & Licenses
          </button>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="addTrainingModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content rounded-3">
            <div class="modal-header">
              <h5 class="modal-title">Add Training & License</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label fw-semibold">Name</label>
                <input v-model.trim="newTraining.name" type="text" class="form-control" placeholder="Enter training name" />
              </div>
              <div class="mb-3">
                <label class="form-label fw-semibold">Details</label>
                <textarea v-model.trim="newTraining.details" class="form-control" placeholder="Enter training details"></textarea>
              </div>
              <div class="mb-3">
                <label class="form-label fw-semibold">Status</label>
                <select v-model="newTraining.status" class="form-select">
                  <option disabled value="">Select status</option>
                  <option>Completed</option>
                  <option>In Progress</option>
                  <option>Expired</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-outline-secondary rounded-pill" data-bs-dismiss="modal">Cancel</button>
              <button class="btn btn-primary rounded-pill" @click="addTraining" data-bs-dismiss="modal">Add</button>
            </div>
          </div>
        </div>
      </div>


      <button
        v-if ="activeTab !== 'Additional'"
        class="btn text-white mt-3"
        :disabled="saving"
        @click="updateProfile"
        style="background: linear-gradient(to right, #d946ef, #8b5cf6); border: 0;"
      >
        <span v-if="saving" class="spinner-border spinner-border-sm me-2"></span>
        Save Changes
      </button>
    </form>
    
  </div>
  <div class="card p-4 shadow-sm" v-if="tab === 'company'">
  <h3 class="fw-bold mb-4">Company Information</h3>

  <form @submit.prevent="saveCompanyInfo">
    <div class="row g-3">
      <!-- Company Logo -->


      <!-- Company Name -->
      <div class="col-md-6">
        <label class="form-label fw-semibold">Company Name</label>
        <input
          v-model.trim="companyForm.companyName"
          type="text"
          class="form-control"
          placeholder="Enter company name"
        />
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold">Industry</label>
        <input
          v-model.trim="companyForm.companyIndustry"
          type="text"
          class="form-control"
          placeholder="Enter Industry"
        />
      </div>

      <!-- Company Address -->
      <div class="col-12">
        <label class="form-label fw-semibold">Company Address</label>
        <textarea
          v-model.trim="companyForm.companyAddress"
          class="form-control"
          placeholder="Enter company address"
        ></textarea>
      </div>

      <!-- Postal Code -->
      <div class="col-md-6">
        <label class="form-label fw-semibold">Postal Code</label>
        <input
          v-model.trim="companyForm.postalCode"
          type="text"
          maxlength="6"
          class="form-control"
          placeholder="e.g. 123456"
        />
      </div>

      <!-- Contact Number -->
      <div class="col-md-6">
        <label class="form-label fw-semibold">Contact Number</label>
        <input
          v-model.trim="companyForm.contactNumber"
          type="text"
          class="form-control"
          placeholder="+65 9123 4567"
        />
      </div>

      <div class="col-12">
        <label class="form-label fw-semibold">Company Logo</label>
        <input 
          type="file" 
          class="form-control" 
          ref="logoInput"
          accept="image/png, image/jpeg"
        />
        <div v-if="companyForm.logoUrl" class="mt-2">
          <img :src="companyForm.logoUrl" alt="Logo Preview" class="img-thumbnail" style="max-height: 80px;" />
        </div>
      </div>

    </div>
    

    <button
      class="btn text-white mt-3"
      :disabled="companySaving"
      style="background: linear-gradient(to right, #d946ef, #8b5cf6); border: 0;"
    >
      <span v-if="companySaving" class="spinner-border spinner-border-sm me-2"></span>
      Save Company Info
    </button>
  </form>
</div>


  <!-- <div class="space-y-6" v-if="tab === 'plans'">
    <div class="border rounded-xl overflow-hidden mt-6" > -->
      <!-- Header -->
      <!-- <div class="p-6 border-b">
        <h2 class="text-xl font-semibold">Current Plan</h2>
      </div> -->


        <!-- Content -->
        <!-- <div class="p-6">
          <div class="flex items-center justify-between p-4 border rounded-lg bg-gradient-to-r from-indigo-50 to-white dark:from-indigo-900/20 dark:to-transparent">
            <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center"> -->
            <!-- Crown icon inline SVG -->
            <!-- <Crown />
            </div>
              <div>
                <p class="font-semibold">{{capitalizeFirstWord(this.currentPlan)}} Plan</p>
                <p class="text-sm text-muted-foreground">{{currentPlanDict.description}}</p>
              </div>
            </div> -->


            <!-- <div class="text-right">
              <p class="font-semibold" v-if= "currentPlanDict.price<15000">${{currentPlanDict.price}}/month</p>
              <p class="font-semibold" v-if= "currentPlanDict.price>=15000">Custom</p>
            </div>
          </div>
        </div>
    </div>
    <div class="border rounded-xl overflow-hidden"> -->
      
      <!-- Header -->
      <!-- <div class="p-6 border-b">
        <h2 class="text-xl font-semibold">Choose Your Plan</h2>
        <p class="text-sm text-muted-foreground">Select the plan that best fits your agency needs</p>
      </div> -->

      <!-- Content -->
      <!-- <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6">
          <div
            v-for="(plan, index) in visiblePlans"
            :key="index"
            :class="[
              'relative border rounded-lg p-6 transition-colors',
              plan.name.toLowerCase() == this.currentPlan.toLowerCase() ? 'border-indigo-600 bg-indigo-50/60 dark:bg-indigo-900/20' : 'border-border bg-background'
            ]"
          > -->
            <!-- Current badge -->
            <!-- <div v-if="plan.name.toLowerCase() == this.currentPlan.toLowerCase()" class="absolute -top-3 left-1/2 -translate-x-1/2">
              <span class="px-2 py-1 text-xs rounded-full text-white bg-indigo-600 shadow">Current Plan</span>
            </div>

            <div class="text-center space-y-4">-->
              <!-- Title + desc -->
             <!-- <div>
                <h3 class="font-semibold text-lg">{{ plan.name }}</h3>
                <p class="text-sm text-muted-foreground">{{ plan.description }}</p>
              </div> -->

              <!-- Price -->
             <!-- <div v-if= "plan.price<15000">
                <span class="text-3xl font-bold"  >${{ plan.price }}</span>
                <span class="text-muted-foreground">/month</span>
              </div> -->
             <!-- <div v-if= "plan.price>=15000">
                <span class="text-3xl font-bold"  >Custom</span>-->
                <!-- <span class="text-muted-foreground">/month</span> -->
             <!--</div> -->

              <!-- Features -->
               <!--<ul class="space-y-2 text-sm text-left">
                <li
                  v-for="(feature, idx) in plan.features"
                  :key="idx"
                  class="flex items-center gap-2"
                >
                  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path class="text-green-500" d="M20 6L9 17l-5-5" />
                  </svg>
                  <span>{{ feature }}</span>
                </li>
              </ul> -->

              <!-- Button -->
               <!--<button v-if="plan.price < 15000"
                class="w-full rounded-lg px-4 py-2 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                :class="plan.name.toLowerCase() == this.currentPlan.toLowerCase()
                  ? 'bg-transparent border border-indigo-600 text-indigo-700 hover:bg-indigo-50/70 focus:ring-indigo-600'
                  : 'bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-600'"
                :disabled="plan.name.toLowerCase() == this.currentPlan.toLowerCase() || updatingPlan"
                @click="checkPlanRank(plan,'subscription')"
              >
                <span v-if="updatingPlan && updatingPlanName === plan.name" 
                      class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                <span>
                  {{ plan.name.toLowerCase() == this.currentPlan.toLowerCase() ? 'Current Plan' : 'Upgrade' }}
                </span>
              </button>

              <button v-if="plan.price >= 15000"
                class="w-full rounded-lg px-4 py-2 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                :class="plan.name.toLowerCase() == this.currentPlan.toLowerCase()
                  ? 'bg-transparent border border-indigo-600 text-indigo-700 hover:bg-indigo-50/70 focus:ring-indigo-600'
                  : 'bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-600'"
                :disabled="plan.name.toLowerCase() == this.currentPlan.toLowerCase() || updatingPlan"
                @click="openWhatsApp(plan)"
              >
                <span v-if="updatingPlan && updatingPlanName === plan.name" 
                      class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                <span>
                  {{ plan.name.toLowerCase() == this.currentPlan.toLowerCase() ? 'Current Plan' : 'Contact Us' }}
                </span>
              </button>-->

              <!-- <button 
                class="w-full rounded-lg px-4 py-2 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed"
                :class="plan.name.toLowerCase() == this.currentPlan.toLowerCase()
                  ? 'bg-transparent border border-indigo-600 text-indigo-700 hover:bg-indigo-50/70 focus:ring-indigo-600'
                  : 'bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-600'"
                :disabled="true"
                @click="onUpgrade(plan)"
              >
                Coming Soon
              </button> -->
            <!-- </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- <div class="space-y-6" v-if="tab === 'topup' ">
    <div class="border rounded-xl overflow-hidden"> -->
      <!-- Header -->
      <!-- <div class="p-6 border-b">
        <h2 class="text-xl font-semibold">Top Up Your Credit</h2>
        <p class="text-sm text-muted-foreground">Add more credits anytime to keep your work flowing.</p>
      </div> -->

      <!-- Content -->
      <!-- <div class="p-6">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div
            v-for="(plan, index) in topUpPlans"
            :key="index"
            :class="[
              'relative border rounded-lg p-6 transition-colors',
              plan.name.toLowerCase() == this.currentPlan.toLowerCase() ? 'border-indigo-600 bg-indigo-50/60 dark:bg-indigo-900/20' : 'border-border bg-background'
            ]"
          > -->
            <!-- Current badge -->
            <!-- <div v-if="plan.name.toLowerCase() == 'mass'" class="absolute -top-3 left-1/2 -translate-x-1/2">
              <span class="px-2 py-1 text-xs rounded-full text-white bg-amber-600 shadow">Popular</span>
            </div>

            <div class="text-center space-y-4"> -->
              <!-- Title + desc -->
              <!-- <div>
                <h3 class="font-semibold text-lg">{{ plan.name }}</h3>
                <p class="text-sm text-muted-foreground">{{ plan.description }}</p>
              </div> -->

              <!-- Price -->
              <!-- <div>
                <span class="text-3xl font-bold"  >${{ plan.price }}</span>
              </div> -->

              <!-- Features -->
              <!-- <ul class="space-y-2 text-sm text-left">
                <li
                  v-for="(feature, idx) in plan.features"
                  :key="idx"
                  class="flex items-center gap-2"
                >
                  <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path class="text-green-500" d="M20 6L9 17l-5-5" />
                  </svg>
                  <span>{{ feature }}</span>
                </li>
              </ul> -->

              <!-- Button -->
              <!-- <button v-if= "plan.price<15000"
                class="w-full rounded-lg px-4 py-2 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed"
                :class="plan.name.toLowerCase() == this.currentPlan.toLowerCase()
                  ? 'bg-transparent border border-indigo-600 text-indigo-700 hover:bg-indigo-50/70 focus:ring-indigo-600'
                  : 'bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-600'"
                :disabled="plan.name.toLowerCase() == this.currentPlan.toLowerCase()"
                @click="onUpgrade(plan)"
              >
                Top Up
              </button> -->
              <!-- <button 
                class="w-full rounded-lg px-4 py-2 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                :class="plan.name.toLowerCase() == this.currentPlan.toLowerCase()
                  ? 'bg-transparent border border-indigo-600 text-indigo-700 hover:bg-indigo-50/70 focus:ring-indigo-600'
                  : 'bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-600'"
                :disabled="updatingPlan"
                @click="startCheckout(plan,'payment')"
              >
                <span v-if="updatingPlan && updatingPlanName === plan.name"
                      class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                <span>Buy Now!</span>
              </button> -->

            <!-- </div>
          </div> 
        </div>
      </div>
    </div>
  </div>-->

  </Layout>
</template>


<script>
import Layout from '@/components/Layout.vue';
import axios from "axios";
import { getAuth,onAuthStateChanged } from "firebase/auth";
import { useToast } from "vue-toastification";
import router from "@/router";
// import { Crown } from 'lucide-vue-next';


export default {
  name: 'MainLayout',
  components: { Layout },
  data() {
    return {
      whatsappUrl: "https://wa.me/+6582266460",
      // apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      saving: false,
      companySaving:false,
      updatingPlan:false, 
      form: {
        // Identity
        legalName: "",
        name: "",
        nricPassport: "",
        dob: "",
        nationality: "",
        employeeStatus: "",

        // Contact
        personalEmail: "",
        email: "",
        mobileNumber: "",
        photoUrl: "",
        homeAddress: "",
        emergencyContacts: [
          { name: "", relationship: "", phone: "" }
        ],

        // Job Info
        position: "",
        gradeLevel: "",
        department: "",
        costCentre: "",
        managerId: "",
        employmentType: "",
        workArrangement: "",
        workLocation: "",
        joinDate: "",
        probationEndDate: "",
        noticePeriod: "",

        // Payroll
        employmentBasis: "fulltime", // or parttime
        baseSalary: 0,
        currency: "SGD",
        paySchedule: "",
        cpfStatus: "",
        taxResidency: "",
        irasAutoInclusion: "",
        hourlyRate: 0,
        hoursWorked: 0,
        bankDetails: {
          accountName: "",
          bankName: "",
          branchCode: "",
          accountNumber: ""
        },
        allowances: [], // {id, name, amount}
        deductions: [], // {id, name, amount}
        payrollHistory: [], // {month, base, allowances, deductions, cpfEmployee, cpfEmployer, tax, net, status}

        // Compliance
        workPass: {
          type: "",
          number: "",
          issueDate: "",
          expiryDate: ""
        },
        contractSigned: "",
        ndaSigned: false,
        handbookAcknowledged: false,
        pdpaConsent: false,
        leaveEntitlements: [],

        // Additional (only trainings left)
        // trainings: [
        //   { name: "XXX ", details: "XXX", status: "XXX" }
        // ]
      },
      companyForm: {
        logoUrl: "",         // string (uploaded logo URL or base64 preview)
        companyName: "",     // string
        companyAddress: "",  // string
        postalCode: "",      // string, keep max 6 chars for SG
        contactNumber: "",    // string, e.g. "+65 9123 4567"
        companyIndustry:""
      },
      currentPlan:"",
      userID: "",
      token: "",
      tab:"profile",
      subPlans: [],
      topUpPlans: [],
      currentPlanDict:{},
      activeTab: "Identity",
      detailTabs: [
        "Identity",
        "Contact",
        "Job Info",
        "Payroll",
        "Compliance",
      ],
      newTraining: {
        name: "",
        details: "",
        status: ""
      }

    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    visiblePlans() {
      if (this.currentPlanDict?.name?.toLowerCase() === "enterprise") {
        // only keep enterprise
        return this.subPlans.filter(
          plan => plan.name.toLowerCase() === "enterprise"
        )
      } else {
        // show all except free trial
        return this.subPlans.filter(
          plan => plan.name.toLowerCase() !== "free trial"
        )
      }
    }
  },
  async mounted(){
      this.userID = this.$store.getters.getUserId;
      await this.checkAuthState();
      await this.fetchProfile();
      await this.fetchPlans();
      await this.loadCompanyInfo();
      // this.fetchMeetingsByDate();
  },

  methods:{
    onPhotoUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      // Only allow image files
      const allowedTypes = ["image/jpeg", "image/png"]
      if (!allowedTypes.includes(file.type)) {
        this.$toast?.error("Only JPG and PNG allowed") // optional if using toast
        return
      }

      // Preview image
      const reader = new FileReader()
      reader.onload = (e) => {
        this.form.photoUrl = e.target.result
      }
      reader.readAsDataURL(file)

      // ⚡ later: upload to backend or Firebase Storage if needed
      this.photoFile = file // keep original file in memory if you want to upload
    },
    async saveCompanyInfo() {
      this.companySaving = true;
      try {
        const formData = new FormData();

        // attach file if exists
        if (this.$refs.logoInput && this.$refs.logoInput.files[0]) {
          formData.append("file", this.$refs.logoInput.files[0]);
        }

        // attach text fields
        formData.append("companyName", this.companyForm.companyName);
        formData.append("companyIndustry", this.companyForm.companyIndustry);
        formData.append("companyAddress", this.companyForm.companyAddress);
        formData.append("postalCode", this.companyForm.postalCode);
        formData.append("contactNumber", this.companyForm.contactNumber);

        const res = await axios.put(`${this.apiURL}/api/company`, formData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "multipart/form-data"
          }
        });

        this.toast.success("Updated Successfully")
        if (res.data.logoUrl) {
          this.companyForm.logoUrl = res.data.logoUrl; // update preview
        }
      } catch (err) {
        this.toast.error("Error saving company info");
      } finally {
        this.companySaving = false;
      }
    },
     async loadCompanyInfo() {
      try {
        const res = await axios.get(`${this.apiURL}/api/company`, {
          headers: { Authorization: this.token }   // pass your Firebase token here
        });
        this.companyForm = res.data.data;
      } catch (err) {
        console.error("Error loading company info:", err);
      }
    },
    async cancelNow(reason = "") {
      this.updatingPlan = true;
      try {
        const headers = await this.getAuthHeader();
        const body = { userID: this.userID, reason };
        const { data } = await axios.post(`${this.apiURL}/subscription/cancel`, body, { headers });

        this.planStatus = data.status; // "canceled"
        this.subscriptionId = data.subscriptionId;
        this.toast.success("Unsubscribe Successful");
        this.fetchProfile()
      } catch (err) {
        console.error(err);
        this.toast.error("Unsubscribe failed");
      } finally {
        this.updatingPlan = false;
      }
    },
    async checkPlanRank(plan,mode){
      // console.log(this.currentPlanDict["planRank"],plan["planRank"],mode )
      let currPlanRank = this.currentPlanDict["planRank"]
      if (currPlanRank == 0){
          await this.startCheckout(plan, mode)
      }else{
        if (currPlanRank < plan["planRank"]){
            await this.upgradePlan(plan, true)
        }
        else{
            if (this.downgradeAvail){
                if (plan["planRank"] ==0){
                  await this.cancelNow("")
                }else{
                  await this.upgradePlan(plan, false)
                }
            }else{
              this.toast.error("Downgrading Limit will be only available next month as limit of downgrading have reached")
            }
        }
      }
    },
    async upgradePlan(plan, isUpgrade) {
      // charge pro-rated difference now
      this.updatingPlan = true;
      let planUpgradeType = "downgrade"
      let prorationType = "None"
      if (isUpgrade){
        planUpgradeType = "upgrade"
        prorationType = "create_prorations"
      }
      try {
        const headers = await this.getAuthHeader();
        const body = {
          priceId: plan["priceID"],
          userId: this.userID,
          prorationBehavior: prorationType,
          modifyType: planUpgradeType
          // subscriptionId not needed since your backend looks it up by userId
        };

        await axios.post(`${this.apiURL}/changePlan`, body, { headers });
        await this.fetchProfile()
        this.toast.success(`Upgraded! New plan active.`);
      } catch (err) {
        console.error(err);
        this.toast.error("Upgrading/Downgrading failed");
      } finally {
        this.updatingPlan = false;
      }
    },
    async startCheckout(plan, mode) {
      try {
        this.updatingPlan = true;
        const headers = await this.getAuthHeader();

        const res = await axios.post(this.apiURL+"/checkout", {
          priceId: plan["priceID"],
          userId:this.userID,
          mode: mode   // "payment" for top-up, "subscription" for sub
        },{headers});

        if (res.data.checkoutUrl) {
          // Redirect user to Stripe Checkout
          window.location.href = res.data.checkoutUrl;
        } else {
          console.error("No checkoutUrl returned:", res.data);
          this.toast.error("Checkout failed. Please try again.");

        }
      } catch (err) {
        console.error("Checkout error:", err);
        this.toast.error("Error starting checkout.");
      }finally{
        this.updatingPlan = false;
      }
    },
    openWhatsApp() {
      window.open(this.whatsappUrl, "_blank");
    },
    getCurrentPlan() {
      let subPlans = this.subPlans
      let currentPlan = this.currentPlan
      
      if (!subPlans || !currentPlan) return null;
      return subPlans.find(
        (plan) => plan.name.toLowerCase() === currentPlan.toLowerCase()
      ) || null;
    },
    capitalizeFirstWord(text) {
      if (!text) return '';
      // Split by space, only change first word
      const words = text.trim().split(' ');
      if (words.length === 0) return '';
      words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
      return words.join(' ');
    },
    async fetchPlans() {
      try {
        const headers = await this.getAuthHeader();

        const res = await axios.get(`${this.apiURL}/getPlans`, {
          headers,
        });

        if (res.data.code === 200) {
          console.log(res.data)
          this.subPlans = res.data.subscription;
          this.topUpPlans = res.data.topup;
          this.currentPlanDict = this.getCurrentPlan()
        } else {
          console.log(res.data.code)
          this.toast.error(res.data.message || "Failed to load plans");
        }
      } catch (err) {
        console.error(err);
        this.toast.error("Error loading Plans");
      }
    },

    async checkAuthState() {
      const auth = getAuth();
      return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, async (user) => {
            if (user) {
            try {
                const idToken = await user.getIdToken();
                this.token = idToken;
                resolve(); // 🔥 Only resolve when token is ready
            } catch (error) {
                reject(error);
            }
            } else {
            router.push("/");
            reject(new Error("No user logged in"));
            }
        });
      });
    },
    async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');

      const token = await user.getIdToken(); // 🔐 always fresh
      return {
        Authorization: token
      };
    },
    async fetchProfile() {
      try {
        const headers = await this.getAuthHeader(); // 🔹 Get Firebase token

        const res = await axios.get(`${this.apiURL}/getEmployee/${this.userID}`, {
          headers
        });

        if (res.data.code === 200) {
          const data = res.data.data;

          // ✅ Map backend data to form
          this.form = {
            // ===== Identity =====
            legalName: data.profile?.legalName || "",
            name: data.profile?.Name || "",
            dob: data.profile?.dob || "",
            employeeStatus: data.profile?.employeeStatus || "",

            // ===== Contact =====
            personalEmail: data.contact?.personalEmail || "",
            email: data.contact?.Email || "",
            mobileNumber: data.contact?.mobileNumber || "",
            photoUrl: data.contact?.photoUrl || "",
            homeAddress: data.contact?.homeAddress || "",
            emergencyContacts: data.contact?.emergencyContacts || [
              { name: "", relationship: "", phone: "" }
            ],

            // ===== Job Info =====
            position: data.jobInfo?.position || "",
            gradeLevel: data.jobInfo?.gradeLevel || "",
            department: data.jobInfo?.department || "",
            costCentre: data.jobInfo?.costCentre || "",
            managerId: data.jobInfo?.managerId || "",
            employmentType: data.jobInfo?.employmentType || "",
            workArrangement: data.jobInfo?.workArrangement || "",
            workLocation: data.jobInfo?.workLocation || "",
            joinDate: data.jobInfo?.joinDate || "",
            probationEndDate: data.jobInfo?.probationEndDate || "",
            noticePeriod: data.jobInfo?.noticePeriod || "",

            // ===== Payroll =====
            employmentBasis: data.payroll?.employmentBasis || "fulltime",
            baseSalary: data.payroll?.baseSalary || 0,
            currency: data.payroll?.currency || "SGD",
            paySchedule: data.payroll?.paySchedule || "",
            hourlyRate: data.payroll?.hourlyRate || 0,
            hoursWorked: data.payroll?.hoursWorked || 0,
            bankDetails: {
              accountName: data.payroll?.bankDetails?.accountName || "",
              bankName: data.payroll?.bankDetails?.bankName || "",
              branchCode: data.payroll?.bankDetails?.branchCode || "",
              accountNumber: data.payroll?.bankDetails?.accountNumber || ""
            },
            allowances: data.payroll?.allowances || [],
            deductions: data.payroll?.deductions || [],
            payrollHistory: data.payroll?.payrollHistory || [],

            // ===== Compliance =====
            workPass: {
              type: data.compliance?.workPass?.type || "",
              number: data.compliance?.workPass?.number || "",
              issueDate: data.compliance?.workPass?.issueDate || "",
              expiryDate: data.compliance?.workPass?.expiryDate || ""
            },
            contractSigned: data.compliance?.contractSigned || "",
            ndaSigned: data.compliance?.ndaSigned || false,
            handbookAcknowledged: data.compliance?.handbookAcknowledged || false,
            pdpaConsent: data.compliance?.pdpaConsent || false,
            leaveEntitlements: data.compliance?.leaveEntitlements || [
            ],

          };

          // ===== Current Plan =====
          this.currentPlan = res.data.currPlan || "";
          this.currentPlanDict = this.getCurrentPlan();

          this.toast.success("Profile loaded successfully!");
        } else {
          this.toast.error(res.data.message || "Failed to load profile");
        }
      } catch (err) {
        console.error("Error fetching profile:", err);
        this.toast.error("Error loading profile");
      }
    },
    async updateProfile() {
      // ✅ Basic validation
      const name = (this.form.name || '').trim();
      const email = (this.form.email || '').trim();
      const emailOk = !email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!name && !email) {
        this.toast.error('At least name or email must be filled');
        return;
      }
      if (!emailOk) {
        this.toast.error('Email format not valid');
        return;
      }

      try {
        this.saving = true;
        const headers = await this.getAuthHeader(); // 🔐 Must include Authorization token

        // ============================================================
        // Construct payload exactly matching backend allowed fields
        // ============================================================
        const payload = {
          id: this.userID,
          legalName: this.form.legalName,                // encrypted by backend
          name:name, 
          email: email,                   // encrypted by backend
          personalEmail: this.form.personalEmail || "",
          mobileNumber: this.form.mobileNumber || "",
          homeAddress: this.form.homeAddress || "",
          dob:this.form.dob,
          emergencyContacts: this.form.emergencyContacts || [],
          payroll: {
            bankDetails: {
              accountName: this.form.bankDetails.accountName || "",
              bankName: this.form.bankDetails.bankName || "",
              branchCode: this.form.bankDetails.branchCode || "",
              accountNumber: this.form.bankDetails.accountNumber || ""
            }
          },
          trainings: this.form.trainings || []
        };

        console.log("Sending payload:", payload);

        // ============================================================
        // API call to update profile
        // ============================================================
        const res = await axios.put(`${this.apiURL}/updateProfile`, payload, { headers });

        if (res.data.code === 200) {
          this.toast.success('Profile updated successfully');
          // Optionally re-fetch profile to reflect latest changes
          await this.fetchProfile();
        } else {
          this.toast.error(res.data.message || 'Update failed');
        }
      } catch (err) {
        console.error("Update error:", err);
        this.toast.error(err.response?.data?.message || 'Update error, try again later');
      } finally {
        this.saving = false;
      }
    }


  }

};
</script>

<style scoped>

</style>